<template>
  <!-- 掌签 -->
  <div class="zhangqian">
    掌签
  </div>
</template>

<script>
export default{
  props: ['order_id'],
  data(){
    return{}
  },
  methods:{
  },
  created(){}
}
</script>

<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/views/fengkong/operation/zhangQian.vue